import { useEffect } from "react";
import { createGlobalStyle } from "styled-components";

export const GlobalCritical = createGlobalStyle`  
  @font-face {
    font-family: "Gilroy";
    src: url(/fonts/Gilroy/Gilroy-Bold.woff2) format("woff2");
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    size-adjust: 100%;
    ascent-override: 92%;
    descent-override: 22%;
    line-gap-override: 0%;
  }  
  
  @font-face {
    font-family: "Gilroy";
    src: url(/fonts/Gilroy/Gilroy-Medium.woff2) format("woff2");
    font-weight: 300;
    font-style: normal;
    font-display: swap;
    size-adjust: 100%;
    ascent-override: 92%;
    descent-override: 22%;
    line-gap-override: 0%;
  }

  @font-face {
    font-family: "EditorialNew";
    src: url(/fonts/EditorialNew/PPEditorialNew-Regular.otf) format("woff2");
    font-display: swap;
    font-weight: 300;
    font-style: normal;
  }  

  :root{
    --bg-header-color: rgba(13,15,16,.6);
    --primary-color:#0D0F10; 
    --second-color:#E9E9E9; 
    --third-color:#8a8a8a;
    --four-color:#1e1e1e;
    --gradient:linear-gradient(to top,transparent,var(--third-color));
    --font: "Gilroy";
    --font-title: "EditorialNew";
    --font-subtitle:"Gilroy";
  }

  .white {
    --bg-header-color: rgba(233, 233, 233, 0.6);
    --primary-color:#E9E9E9; 
    --second-color:#0D0F10; 
    --third-color:#5e5e5e;
    --four-color:#e7e7e7;
    --gradient: linear-gradient(to top, transparent, var(--third-color));
    --font: "Gilroy";
    --font-title: "EditorialNew";
    --font-subtitle:"Gilroy";
  }

  *{ margin:0; padding:0; border:0; box-sizing:border-box; font-family:var(--font); text-align: center; }

  html,body{
    width:100%;
    scroll-behavior:smooth;
    word-break:break-word;
    background-color:var(--primary-color);   
    color:var(--second-color);
    font-synthesis: none;
  }

  body{ color-scheme: dark; }
  body.white{ color-scheme: light; }
  body.black{ color-scheme: dark; }

  main{ position:relative; width:100%; height:100%; margin:auto; background-color:var(--primary-color); }

  a{ color:inherit; text-decoration:none; }
  img{ max-width:100%; height:auto; display:block; }
`;
